import { delay } from 'q'
import {
	ResellerServiceInterface,
	Reseller,
	ResellerFormValues,
	EndCustomer,
	SingleResponse,
	ListResponse,
	ReportEntry,
	ResellerLicense,
	ResellerLicenseLimitWarning
} from '../types'
import { createFakeListResponse, createFakeSingleResponse } from './fakes/createFakeResponse'
import resellers from './fakes/resellers'
import report from './fakes/report'

const createResellerObject = (id: number, values: ResellerFormValues): Reseller => ({ id, ...values })

export default class MockResellerService implements ResellerServiceInterface {
	public async getAll(): Promise<ListResponse<Reseller>> {
		await delay(500)
		return createFakeListResponse(resellers)
	}

	public async getById(id: number): Promise<SingleResponse<Reseller>> {
		await delay(500)
		return createFakeSingleResponse(resellers.filter(reseller => reseller.id === id)[0])
	}

	public async delete(id: number): Promise<void> {
		await delay(500)
		const index = resellers.findIndex(customer => customer.id === id)
		resellers.splice(index, 1)
	}

	public async edit(id: number, values: ResellerFormValues): Promise<SingleResponse<Reseller>> {
		await delay(1000)
		const index = resellers.findIndex(reseller => reseller.id === id)
		const reseller = createResellerObject(id, values)
		resellers.splice(index, 1, reseller)
		return createFakeSingleResponse(reseller)
	}

	public async create(values: ResellerFormValues): Promise<SingleResponse<Reseller>> {
		await delay(500)
		const id = Math.floor(Math.random() * 100)
		const reseller = createResellerObject(id, values)
		resellers.push(reseller)
		return createFakeSingleResponse(reseller)
	}

	public async getChildren(): Promise<ListResponse<EndCustomer>> {
		return createFakeListResponse([])
	}

	public async getReport(): Promise<SingleResponse<ReportEntry>> {
		return createFakeSingleResponse(report[0])
	}

	public async getCsvReport(): Promise<SingleResponse<string>> {
		return createFakeSingleResponse('')
	}

	public async getLicenses(): Promise<SingleResponse<Record<string, ResellerLicense>>> {
		return {
			data: {
				CRM: {
					id: 1,
					type: 'CRM',
					allocated: 10,
					consumed: 10,
					display_name: 'CRM',
					is_limit_enabled: true,
					limit: 10,
					is_nfr: false,
				}
			}
		}
	}

	public async getLicensesNearLimit(): Promise<SingleResponse<Record<string, ResellerLicenseLimitWarning>>> {
		return {
			data: {
				CRM: {
					type: 'CRM',
					unallocated: 5
				}
			}
		}
	}

	public async updateLicense(): Promise<void> {
		return
	}
}
